/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import urlTemplate from 'url-template';
import { useEffect, useRef } from 'react';

// eslint-disable-next-line no-unused-vars
const Video = ({ video, overlay }) => {
  const videoElement = useRef(null);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      videoElement.current.removeAttribute('autoPlay');
    }

    function addSourceToVideo(element, src) {
      const source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      videoElement.current.appendChild(source);
    }

    if (window.innerWidth > 767) {
      addSourceToVideo(videoElement, videoElement.current.dataset.desktopVideo);
    } else {
      addSourceToVideo(videoElement, videoElement.current.dataset.mobileVideo);
    }
  }, []);

  if (!video.media.cloudinaryUriTemplate) {
    return null;
  }

  const template = urlTemplate.parse(
    video.media.cloudinaryUriTemplate.replace('/image/', '/video/'),
  );

  const transformationTemplate = urlTemplate.parse(
    'c_fill{gravity}{height}{width}{format}{startOffset}{quality}{left}{top}/',
  );

  const mobileTransformations = decodeURIComponent(
    transformationTemplate.expand({
      quality: ',q_auto',
      width: ',w_500',
      height: ',h_282',
    }),
  );

  const desktopTransformations = decodeURIComponent(
    transformationTemplate.expand({
      quality: ',q_auto',
    }),
  );

  const posterTransform = transformationTemplate.expand({
    quality: ',q_auto',
    format: ',f_jpg',
    startOffset: ',so_0',
  });

  return (
    <video
      className="gw-top-image__video"
      ref={videoElement}
      autoPlay
      loop
      playsInline
      muted
      poster={template.expand({
        transform: posterTransform,
      })}
      data-mobile-video={template.expand({
        transform: mobileTransformations,
      })}
      data-desktop-video={template.expand({
        transform: desktopTransformations,
      })}
    />
  );
};

export default Video;
